import { render, staticRenderFns } from "./AppConfig.vue?vue&type=template&id=c2341a86"
import script from "./AppConfig.vue?vue&type=script&lang=ts"
export * from "./AppConfig.vue?vue&type=script&lang=ts"
import style0 from "./AppConfig.vue?vue&type=style&index=0&id=c2341a86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports